import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { Province } from '../entities/province';

@Injectable()
export class ProvinceService extends BaseCrudService<Province>{
    public uri = '/api/province/';

    constructor(injector: Injector) {
        super(injector);
       //console.log('Instance ProvinceService');
    }

    buildSentence(entity?: Province, event?: LazyLoadEvent): HttpParams {
        if (entity) {
            let query = entity.code ? 'code' + QueryOperator.Contain + entity.code + QueryOperator.Split : QueryOperator.Empty;
            query = query.concat(entity.name ? 'name' + QueryOperator.Contain + entity.name + QueryOperator.Split : QueryOperator.Empty);

            if (entity.department) {
                query = query.concat(entity.department.id ? 'department.id' + QueryOperator.Equal + entity.department.id + QueryOperator.Split : QueryOperator.Empty);
            }
            this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
        }

        if (event) {
            const page = ((event.first + event.rows) / event.rows - 1 ).toString();
            const size = event.rows.toString();
            this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
            this.httpParams =  this.httpParams.set(QueryOperator.SizeParam, size);
        }
        return this.httpParams;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/province.service.ts